import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { fail_product_list, loading_product_list, reset_product_list, success_product_list } from '../../../../../../reducers/dashboard_reducers/products/product_list_Slice';
import { ADD_LOADING_ORDER_PRODUCTS_ACCESS_DENIED_MSG, ADD_LOADING_ORDER_PRODUCTS_ERR_MSG, ADD_LOADING_ORDER_PRODUCTS_SUCCESS_MSG, RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG, RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG, RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG, RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_LIST_ERR_MSG, RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ACCESS_DENIED_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_ERR_MSG, RETRIEVE_WAREHOUSE_STORAGE_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { ADD_PRODUCTS_TO_LOADING_ORDER_API, RETRIEVE_ACTIVE_AVAILABLE_PRODUCTS_API, RETRIEVE_ACTIVE_PRODUCT_LIST, RETRIEVE_BRANCH_LOCATION_LIST } from '../../../../../../api/api_data';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { messageToast } from '../../../../../../utils/Utils';
import { Block, BlockBetween, BlockHead, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, Row, RSelect } from '../../../../../../components/Component';
import { Alert } from 'reactstrap';
import { getSelectedOption } from '../../../../../../utils/functionalUtils';
import TextInput from '../../../../../components/inputs/TextInput';
import ModalConfirmCancel from '../../modal_confirm_cancel/ModalConfirmCancel';
import { fail_add_product_to_loading_order, loading_add_product_to_loading_order, reset_add_product_to_loading_order, success_add_product_to_loading_order } from '../../../../../../reducers/dashboard_reducers/loading_orders/add_product_to_loading_order_Slice';
import { fail_retrieve_warehouse_storages_list, loading_retrieve_warehouse_storages_list, reset_retrieve_warehouse_storages_list, success_retrieve_warehouse_storages_list } from '../../../../../../reducers/dashboard_reducers/warehouse/retrieve_warehouse_storages_list_Slice';
import { fail_branch_location_list, loading_branch_location_list, reset_branch_location_list, success_branch_location_list } from '../../../../../../reducers/dashboard_reducers/branch_locations/branch_location_list_Slice';

const initialState = { branch_location_label: "", branch_location_id: "", warehouse_storage_type_id: "", warehouse_storage_label: "", delivery_location: "", product_label: "", product_id: "", product_type_label: "", product_type_id: "", weight_in_kilos: "", quantity_available: "", packaging_number: "", quantity_in_mt: "", packet_size: "", base_weight_in_kilos: "" };
const UNKNOWN_PACKET_SIZE = "Unknown";
const UNKNOWN_PACKET_SIZE_OPTION = { label: UNKNOWN_PACKET_SIZE, value: UNKNOWN_PACKET_SIZE };

const isUnknownPacketSize = (packetSize) => String(packetSize || "").toLowerCase() === UNKNOWN_PACKET_SIZE.toLowerCase();

const isGrainProduct = (productType = "", product = "") =>
  [productType, product].some((value) => String(value || "").toLowerCase().includes("grain"));

const getPacketSizeOptions = (packetSizes = [], allowUnknown = false) => {
  if (!allowUnknown)
  {
    return packetSizes;
  }

  const hasUnknownOption = packetSizes.some((option) => isUnknownPacketSize(option?.value || option?.label));
  return hasUnknownOption ? packetSizes : [...packetSizes, UNKNOWN_PACKET_SIZE_OPTION];
};

const AddProductsToLoadingOrderModal = ({ page_data, openModal, successFunction }) => {

  const dispatch = useDispatch();
  const [productListLoading, setProductListLoading] = useState(true);
  const [product_data, setProductData] = useState([]);
  const [branches_data, setBranchesData] = useState([]);
  const [sent_data, setSentData] = useState(page_data);
  const [formData, setFormData] = useState(initialState);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingOrderProductItems, setLoadingOrderProductItems] = useState([]);
  const [branches, setBranches] = useState([]);
  const [warehousestorageslist, setWarehouseStoragesList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [packet_sizes, setPacketSizes] = useState([]);
  const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
  const [error_confirm, setErrorConfirm] = useState(false);


  useEffect(() => {
    if (openModal && page_data)
    {
      setFormData(initialState);
      dispatch(
        employee_dashboard_actions_helper(
          loading_retrieve_warehouse_storages_list,
          success_retrieve_warehouse_storages_list,
          fail_retrieve_warehouse_storages_list,
          RETRIEVE_PRODUCTS_LIST_ERR_MSG,
          RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_ACTIVE_AVAILABLE_PRODUCTS_API,
          null,
          RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
        )
      );

      // To Be Deleted
      // Retrieve Product List
      dispatch(
        employee_dashboard_actions_helper(
          loading_product_list,
          success_product_list,
          fail_product_list,
          RETRIEVE_PRODUCTS_LIST_ERR_MSG,
          RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_ACTIVE_PRODUCT_LIST,
          null,
          RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
        )
      );

      // Retrieve Branch Locations List
      dispatch(
        employee_dashboard_actions_helper(
          loading_branch_location_list,
          success_branch_location_list,
          fail_branch_location_list,
          RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG,
          RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG,
          app_consts.GET,
          RETRIEVE_BRANCH_LOCATION_LIST,
          null,
          RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG
        )
      );


    }
    setSentData(page_data);
    setLoadingOrderProductItems([]);
  }, [openModal, page_data]);

  // const branch_location_list = useSelector((state) => state.branch_location_list.branch_location_list);

  // useEffect(() => {
  //   if (branch_location_list.status !== app_consts.IDLE)
  //   {
  //     if (branch_location_list.status === app_consts.LOADING)
  //     {
  //       setProductListLoading(true);
  //     } else
  //     {
  //       setProductListLoading(false);
  //       if (branch_location_list.status === app_consts.FAIL)
  //       {
  //         messageToast(branch_location_list.message, app_consts.FAIL);
  //       } else if (branch_location_list.status === app_consts.SUCCESS)
  //       {
  //         setBranchesData(branch_location_list.data);
  //         // Set Branch Locations
  //         const branchLocations = Array.from(
  //           new Map(branch_location_list?.data?.map(d => [d?.branch_location_id, { value: d?.branch_location_id, label: `${d.branch_area} - ${d.province_name}` }])).values()
  //         );

  //         setBranches(branchLocations);
  //       }
  //       dispatch(reset_branch_location_list());
  //     }
  //   }
  // }, [branch_location_list]);

  //Listen to State of Product List
  const retrieve_warehouse_storages_list = useSelector((state) => state.retrieve_warehouse_storages_list.retrieve_warehouse_storages_list);

  useEffect(() => {
    if (retrieve_warehouse_storages_list.status !== app_consts.IDLE)
    {
      if (retrieve_warehouse_storages_list.status === app_consts.LOADING)
      {
        setProductListLoading(true);
      } else
      {
        setProductListLoading(false);
        if (retrieve_warehouse_storages_list.status === app_consts.FAIL)
        {
          messageToast(retrieve_warehouse_storages_list.message, app_consts.FAIL);
        } else if (retrieve_warehouse_storages_list.status === app_consts.SUCCESS)
        {
          setBranchesData(retrieve_warehouse_storages_list.data);
          // Set Branch Locations
          const branchLocations = Array.from(
            new Map(retrieve_warehouse_storages_list?.data?.map(d => [d?.branch_location_id, { value: d?.branch_location_id, label: `${d.branch_area} - ${d.province_name}` }])).values()
          );

          setBranches(branchLocations);
        }
        dispatch(reset_retrieve_warehouse_storages_list());
      }
    }
  }, [retrieve_warehouse_storages_list]);


  //Listen to State of Product List
  const product_list = useSelector((state) => state.product_list.product_list);

  useEffect(() => {
    if (product_list.status !== app_consts.IDLE)
    {
      if (product_list.status === app_consts.LOADING)
      {
        setProductListLoading(true);
      } else
      {
        setProductListLoading(false);
        if (product_list.status === app_consts.FAIL)
        {
          messageToast(product_list.message, app_consts.FAIL);
        } else if (product_list.status === app_consts.SUCCESS)
        {
          // Remapp Product Types
          const remapped_product_types = product_list.data?.map((product_type) => { return { label: product_type.product_type, value: product_type.product_type_id }; });
          setProductTypeList(remapped_product_types);
          setProductData(product_list.data);
        }
        dispatch(reset_product_list());
      }
    }
  }, [product_list]);

  const handleBranchLocationChange = (value, label) => {
    // Filter
    // const filtered_data = branches_data?.filter((data) => value === data?.branch_location_id);

    const filtered_data = branches_data?.filter((data) => value === data?.branch_location_id);

    const storage_types = Array.from(
      new Map(filtered_data?.map(d => [d?.warehouse_storage_type_id, { value: d?.warehouse_storage_type_id, label: d?.warehouse_storage_type }])).values()
    );


    // const storage_types = filtered_data?.map((type) => { return { label: type?.storage_type, value: type?.storage_type_id }; });

    setWarehouseStoragesList(storage_types);

    setFormData({ ...formData, ["branch_location_label"]: label, ["branch_location_id"]: value, ["warehouse_storage_type_id"]: "", ["warehouse_storage_label"]: "", ["quantity_available"]: "", ["packet_size"]: "", product_id: "", product_type_id: "", product_label: "", product_type_label: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
  };

  const handleWarehouseStorageChange = (value, label) => {
    // Filter
    const filtered_data = product_data?.filter((data) => value === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const product_types = Array.from(
    //   new Map(filtered_data?.map(d => [d?.product_type_id, { label: d?.product_type, value: d?.product_type_id }])).values()
    // );

    // setProductTypeList(product_types);

    setFormData({ ...formData, ["warehouse_storage_label"]: label, ["warehouse_storage_type_id"]: value, ["quantity_available"]: "", ["packet_size"]: "", product_id: "", product_type_id: "", product_label: "", product_type_label: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
  };

  const handleProductTypeChange = (value, label) => {

    // const filtered_data = product_data?.filter((data) => value === data?.product_type_id && formData?.warehouse_storage_type_id === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const products = Array.from(
    //   new Map(filtered_data?.map(d => [d?.product_id, { label: d?.product_name, value: d?.product_id }])).values()
    // );


    const filtered_data = product_data?.filter((data) => value === data?.product_type_id);

    const products = Array.from(new Map(filtered_data?.flatMap(d => d?.products || []).filter(p => p?.product_id).map(p => [p?.product_id, { label: p?.product_name, value: p?.product_id }])).values());


    setProductsList(products);

    setFormData({ ...formData, ["product_type_label"]: label, ["product_type_id"]: value, ["quantity_available"]: "", ["packet_size"]: "", product_id: "", product_label: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
  };

  const handleProductChange = (value, label) => {

    // const filtered_data = product_data?.filter((data) => value === data?.product_id && formData?.product_type_id === data?.product_type_id && formData?.warehouse_storage_type_id === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const packet_sizes_list = Array.from(
    //   new Map(filtered_data?.map(d => [d?.product_id, { label: d?.uom_description, value: d?.uom_description }])).values()
    // );

    const filtered_data_1 = product_data?.filter((data) => formData?.product_type_id === data?.product_type_id);
    const filtered_data_2 = filtered_data_1?.filter(d => formData?.product_type_id === d?.product_type_id)?.flatMap(d => d?.products || [])?.filter(p => value === p?.product_id);
    const packet_sizes_list = (filtered_data_2?.[0]?.pum_list || []).flatMap(p => p?.uom_details || []).map(u => ({ label: u.packet_size, value: u.packet_size }));

    setPacketSizes(packet_sizes_list);

    setFormData({ ...formData, ["product_label"]: label, ["product_id"]: value, ["quantity_available"]: "", ["packet_size"]: "", weight_in_kilos: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });

  };

  const handlePacketSizeChange = (value) => {

    if (isUnknownPacketSize(value))
    {
      setFormData({ ...formData, ["packet_size"]: UNKNOWN_PACKET_SIZE, weight_in_kilos: "", quantity_available: "", packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: "" });
      return;
    }

    // const filtered_data = product_data?.find((data) => value === data?.uom_description && formData?.product_id === data?.product_id && formData?.product_type_id === data?.product_type_id && formData?.warehouse_storage_type_id === data?.warehouse_storage_type_id && formData?.branch_location_id === data?.branch_location_id);

    // const filtered_data = product_data?.find((data) => value === data?.uom_description && formData?.product_id === data?.product_id && formData?.product_type_id === data?.product_type_id);


    const filtered_data_1 = product_data?.filter((data) => formData?.product_type_id === data?.product_type_id);
    const filtered_data_2 = filtered_data_1?.filter(d => formData?.product_type_id === d?.product_type_id)?.flatMap(d => d?.products || [])?.filter(p => formData?.product_id === p?.product_id);
    const filtered_data_3 = filtered_data_2?.filter(d => d?.pum_list?.some(pl => pl?.uom_details?.some(ud => ud?.packet_size === value)));
    const uom_details_list = filtered_data_3?.flatMap(d => d?.pum_list || []).flatMap(pl => pl?.uom_details?.filter(ud => ud?.packet_size === value) || []);



    setFormData({ ...formData, ["packet_size"]: value, weight_in_kilos: uom_details_list[0]?.measurement_in_kilos, quantity_available: uom_details_list[0]?.available_capacity, packaging_number: "", quantity_in_mt: "", base_weight_in_kilos: uom_details_list[0]?.base_weight_in_kilos });
  };


  const add_products_to_loading_order = () => {
    const unknownPacketSelected = isUnknownPacketSize(formData?.packet_size);

    if (
      !formData?.branch_location_id ||
      !formData?.warehouse_storage_type_id ||
      !formData?.delivery_location ||
      !formData?.product_id ||
      !formData?.product_type_id ||
      !formData?.packaging_number ||
      !formData?.quantity_in_mt ||
      !formData?.packet_size ||
      (!unknownPacketSelected && !formData?.base_weight_in_kilos)
    ) return;

    // Check for Duplicates
    const isDuplicate = loadingOrderProductItems?.find((item) => {
      return item?.branch_location_id === formData.branch_location_id && item?.warehouse_storage_type_id === formData.warehouse_storage_type_id && item?.delivery_location === formData.delivery_location && item?.product_id === formData?.product_id && item?.product_type_id === formData?.product_type_id && item?.packet_size === formData?.packet_size;
    });

    if (isDuplicate)
    {
      messageToast(`Duplicate Entry of ${formData.product_label} at Warehouse ${formData?.branch_location_label}. Storage: ${formData.warehouse_storage_label}`, app_consts.FAIL);
    }
    else
    {
      setLoadingOrderProductItems([...loadingOrderProductItems, { ...formData, branch_location_label: formData?.branch_location_label, branch_location_id: formData?.branch_location_id, warehouse_storage_type_id: formData?.warehouse_storage_type_id, warehouse_storage_label: formData?.warehouse_storage_label, delivery_location: formData?.delivery_location, product_label: formData?.product_label, product_id: formData?.product_id, product_type_label: formData?.product_type_label, product_type_id: formData?.product_type_id, weight_in_kilos: unknownPacketSelected ? "" : formData?.weight_in_kilos, quantity_available: formData?.quantity_available, packaging_number: formData?.packaging_number, packet_size: formData?.packet_size, quantity_in_mt: formData?.quantity_in_mt, base_weight_in_kilos: unknownPacketSelected ? "" : formData?.base_weight_in_kilos, id: Date.now() }]);

      setFormData(initialState);
      setWarehouseStoragesList([]);
      // setProductTypeList([]);
      setProductsList([]);
      setPacketSizes([]);
    }
  };

  const removeOrderItem = (id) => {
    setLoadingOrderProductItems(loadingOrderProductItems.filter(item => item.id !== id));
  };

  const handleSubmit = () => {
    setErrorConfirm("");
    const sent_data = { products: loadingOrderProductItems, loading_order_ref_no: page_data?.loading_order_ref_no };
    dispatch(
      employee_dashboard_actions_helper(
        loading_add_product_to_loading_order,
        success_add_product_to_loading_order,
        fail_add_product_to_loading_order,
        ADD_LOADING_ORDER_PRODUCTS_ERR_MSG,
        ADD_LOADING_ORDER_PRODUCTS_SUCCESS_MSG,
        app_consts.POST,
        ADD_PRODUCTS_TO_LOADING_ORDER_API,
        sent_data,
        ADD_LOADING_ORDER_PRODUCTS_ACCESS_DENIED_MSG
      )
    );
    // 
  };

  // Listen to the Changes
  const product_add_listener = useSelector((state) => state.add_product_to_loading_order.add_product_to_loading_order);

  useEffect(() => {
    if (!openModal)
    {
      return;
    }

    if (product_add_listener.status !== app_consts.IDLE)
    {
      if (product_add_listener.status === app_consts.LOADING)
      {
        setErrorConfirm("");
      } else
      {
        if (product_add_listener.status === app_consts.FAIL)
        {
          messageToast(product_add_listener.message, app_consts.FAIL);
          setErrorConfirm(product_add_listener.message);
        } else if (product_add_listener.status === app_consts.SUCCESS)
        {
          messageToast(ADD_LOADING_ORDER_PRODUCTS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
        }
        dispatch(reset_add_product_to_loading_order());
      }
    }
  }, [product_add_listener]);

  const grainProductSelected = isGrainProduct(formData?.product_type_label, formData?.product_label);
  const unknownPacketSelected = isUnknownPacketSize(formData?.packet_size);
  const packetSizeOptions = getPacketSizeOptions(packet_sizes, grainProductSelected);
  const canAddProduct = Boolean(
    formData?.branch_location_id &&
    formData?.product_id &&
    formData?.warehouse_storage_type_id &&
    formData?.packaging_number &&
    formData?.packet_size &&
    formData?.product_type_id &&
    Number(formData?.quantity_in_mt) > 0 &&
    formData?.delivery_location &&
    formData?.quantity_in_mt &&
    (unknownPacketSelected || formData?.base_weight_in_kilos)
  );

  // Define one shared style for all RSelects
  const rSelectFixedStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: "180px",   // 👈 fixed width
      width: "180px",      // keep consistent inside table
    }),
    input: (provided) => ({
      ...provided,
      minWidth: "100px",   // prevents shrinking while typing
      width: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      minWidth: "180px",
    }),
  };


  return (
    <>
      <div className="card-inner bg-white">
        <Block>
          <BlockHead>
            <BlockTitle tag="h5">Products</BlockTitle>
          </BlockHead>
          {error && (
            <div className="mb-3 w-100">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> {error}{" "}
              </Alert>
            </div>
          )}
          <BlockBetween>
            {
              sent_data?.loading_order_status?.toLowerCase() === app_consts.UNDERGOING_PROCESSING?.toLowerCase() && loadingOrderProductItems?.length > 0 && (
                <>
                  <Button color="primary"
                    size="sm" onClick={() => setOpenConfirmCancelModal(!openConfirmCancelModal)}>Add Products</Button>
                </>
              )
            }
          </BlockBetween>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
              <DataTableRow size="lg"><span className="sub-text">Branch Location</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Storage Type</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Delivery Location</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Product Type</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Weight(KGs)</span></DataTableRow>
              {/* <DataTableRow size="lg"><span className="sub-text">Quantity Available (MT)</span></DataTableRow> */}
              <DataTableRow size="lg"><span className="sub-text">Packaging Number</span></DataTableRow>
              <DataTableRow size="lg"><span className="sub-text">Quantity (MT)</span></DataTableRow>
            </DataTableHead>
            {loadingOrderProductItems.length > 0 &&
              loadingOrderProductItems.map((item) => (
                <DataTableItem key={item.id}>
                  <DataTableRow><span className="tb-sub">{item?.branch_location_label || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.warehouse_storage_label || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.delivery_location || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.product_type_label || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.product_label || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.packet_size || "--"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.base_weight_in_kilos || "0"}</span></DataTableRow>
                  {/* <DataTableRow><span className="tb-sub">{item?.quantity_available || "0"}</span></DataTableRow> */}
                  <DataTableRow><span className="tb-sub">{item?.packaging_number || "0"}</span></DataTableRow>
                  <DataTableRow><span className="tb-sub">{item?.quantity_in_mt || "0"}</span></DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    <Button color="danger" size="sm" onClick={() => removeOrderItem(item.id)}>Remove</Button>
                  </DataTableRow>
                </DataTableItem>
              ))}

            {/* Add New Order Item */}
            <DataTableItem>
              {/* Branch Location */}
              <DataTableRow>
                <RSelect
                  options={branches}
                  className="w-100"
                  placeholder="Search"
                  id="branch_location_id"
                  isLoading={productListLoading}
                  onChange={(e) => { handleBranchLocationChange(e.value, e.label); }}
                  value={getSelectedOption(formData?.branch_location_id, branches)}
                  styles={rSelectFixedStyles}   // 👈 use shared styles
                />
              </DataTableRow>

              {/* Warehouse Storage */}
              <DataTableRow>
                <RSelect
                  options={warehousestorageslist}
                  className="w-100"
                  placeholder="Search"
                  id="warehouse_storage_type_id"
                  onChange={(e) => { handleWarehouseStorageChange(e.value, e.label); }}
                  isDisabled={!formData?.branch_location_id}
                  value={getSelectedOption(formData?.warehouse_storage_type_id, warehousestorageslist)}
                  styles={rSelectFixedStyles}
                />
              </DataTableRow>

              {/* Delivery Location */}
              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="text"
                    value={formData.delivery_location}
                    colSize="10"
                    disabled={!formData?.warehouse_storage_type_id}
                    handleChange={(e) => setFormData({ ...formData, delivery_location: e.target.value })}
                  />
                </Row>
              </DataTableRow>

              {/* Product Type */}
              <DataTableRow>
                <Row className="g-4">
                  <RSelect
                    options={productTypeList}
                    className="w-100"
                    placeholder="Search"
                    id="product_type"
                    onChange={(e) => { handleProductTypeChange(e.value, e.label); }}
                    isDisabled={!formData?.delivery_location}
                    value={getSelectedOption(formData.product_type_id, productTypeList)}
                    styles={rSelectFixedStyles}
                  />
                </Row>
              </DataTableRow>

              {/* Product */}
              <DataTableRow>
                <Row className="g-4">
                  <RSelect
                    options={productsList}
                    className="w-100"
                    placeholder="Search"
                    id="product_id"
                    onChange={(e) => { handleProductChange(e.value, e.label); }}
                    isDisabled={!formData.product_type_id}
                    value={getSelectedOption(formData.product_id, productsList)}
                    styles={rSelectFixedStyles}
                  />
                </Row>
              </DataTableRow>

              {/* Packet Size */}
              <DataTableRow>
                <Row className="g-4">
                  <RSelect
                    options={packetSizeOptions}
                    className="w-100"
                    placeholder="Search"
                    id="packet_size"
                    onChange={(e) => { handlePacketSizeChange(e.value); }}
                    isDisabled={!formData.product_id}
                    value={getSelectedOption(formData.packet_size, packetSizeOptions)}
                    styles={rSelectFixedStyles}
                  />
                </Row>
              </DataTableRow>

              {/* Base Weight */}
              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    value={unknownPacketSelected ? "" : formData.base_weight_in_kilos}
                    colSize="10"
                    disabled
                  />
                </Row>
              </DataTableRow>

              {/* Quantity Available (commented out) */}
              {/* <DataTableRow>
    <Row className="g-4">
      <TextInput
        required
        type="text"
        value={formData?.quantity_available}
        colSize="10"
        disabled
      />
    </Row>
  </DataTableRow> */}

              {/* Packaging Number */}
              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    value={formData?.packaging_number}
                    colSize="10"
                    disabled={!formData?.packet_size}
                    handleChange={(e) => {
                      const selected = parseFloat(e.target.value) || 0;

                      if (unknownPacketSelected)
                      {
                        setFormData({
                          ...formData,
                          packaging_number: selected,
                        });
                        return;
                      }

                      const density = parseFloat(formData.base_weight_in_kilos) || 0;

                      const totalMT = density ? (selected * density) / 1000 : 0;

                      setFormData({
                        ...formData,
                        packaging_number: selected,
                        quantity_in_mt: totalMT,
                      });
                    }}
                  />
                </Row>
              </DataTableRow>

              {/* Quantity in MT */}
              <DataTableRow>
                <Row className="g-4">
                  <TextInput
                    required
                    type="number"
                    value={formData?.quantity_in_mt}
                    colSize="10"
                    disabled={!formData?.packet_size}
                    handleChange={(e) => {
                      const totalMT = parseFloat(e.target.value) || 0;

                      if (unknownPacketSelected)
                      {
                        setFormData({
                          ...formData,
                          quantity_in_mt: totalMT,
                        });
                        return;
                      }

                      const base = parseFloat(formData.base_weight_in_kilos) || 0;

                      const selectedMeasurement = base ? (totalMT * 1000) / base : 0;

                      setFormData({
                        ...formData,
                        quantity_in_mt: totalMT,
                        packaging_number: parseFloat(selectedMeasurement)?.toFixed(2),
                      });
                    }}
                  />
                </Row>
              </DataTableRow>

              {/* Add Button */}
              <DataTableRow>
                <Button
                  color="primary"
                  disabled={loading || !canAddProduct}
                  size="sm"
                  onClick={add_products_to_loading_order}
                >
                  Add
                </Button>
              </DataTableRow>
            </DataTableItem>
          </div>
        </Block>
      </div>

      {/* Yes or No Modal */}
      <ModalConfirmCancel
        openModal={openConfirmCancelModal}
        setOpenModal={setOpenConfirmCancelModal}
        modalTitle={`Add Products to Loading Order ${sent_data?.loading_order_ref_no}`}
        modalDescription={`Are you sure that you want to Add Products to ${sent_data?.loading_order_ref_no}?`}
        buttonConfirm="Confirm"
        buttonCancel="Cancel"
        succFunc={handleSubmit}
        errAmend={error_confirm}
        setErrAmend={setErrorConfirm}
      />
    </>
  );
};

export default AddProductsToLoadingOrderModal;
